import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-brand-gray-900 group-[.toaster]:text-white group-[.toaster]:border-brand-gray-700 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-brand-gray-400",
          actionButton:
            "group-[.toast]:bg-brand-orange group-[.toast]:text-black",
          cancelButton:
            "group-[.toast]:bg-brand-gray-700 group-[.toast]:text-white",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
